import ConfirmDeleteDialog from '../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import { DisplayedMeeting } from '../../types';
import { useDeleteMeetingModal } from './useDeleteMeetingModal';

// Keeps the French quotes and question mark on the meeting title's line.
const NBSP = ' ';

type Props = {
  meeting: DisplayedMeeting;
  onClose: () => void;
};

export function DeleteMeetingModal(props: Props) {
  const { handleConfirm } = useDeleteMeetingModal(props.meeting);

  return (
    <ConfirmDeleteDialog
      title="Supprimer la réunion"
      onConfirm={handleConfirm}
      onClose={props.onClose}
    >
      Êtes-vous sûr de vouloir supprimer la réunion «{NBSP}{props.meeting.title}{NBSP}»
      {props.meeting.report_url ? ' et son compte rendu' : ''}{NBSP}?
    </ConfirmDeleteDialog>
  );
}
